import { TOGGLE_APP_STATE, SIGN_IN } from './constants'

const initialState = {
  isLoading: true,
  rvcUuid: null,
  user: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_APP_STATE: {
      return { ...state, ...payload }
    }

    case SIGN_IN: {
      return {
        ...state,
        user: {
          ...payload,
        },
      }
    }

    default:
      return state
  }
}
